function toggleIngredients() {
    const ingredients = document.querySelector('.ingredients-section__ingredients-hidden');
    const ingredientsButton = document.querySelector('.ingredients-section__ingredients-button');

    // Check if ingredients are currently hidden or shown
    if (ingredientsButton.classList.contains('active')) {
        ingredientsButton.classList.remove('active');

        // For a smooth close, if the height is 'auto' we first set it to the current pixel height.
        if (ingredients.style.height === 'auto') {
            ingredients.style.height = ingredients.scrollHeight + 'px';
            // Force reflow to apply the new fixed height
            ingredients.offsetHeight;
        }
        // Then animate to 0
        ingredients.style.height = '0px';
    } else {
        ingredientsButton.classList.add('active');

        ingredients.style.height = ingredients.scrollHeight + 'px';
        ingredients.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height' && header.classList.contains('active')) {
                ingredients.style.height = 'auto';
            }
            ingredients.removeEventListener('transitionend', handler);
        });
    }
}
